import React from 'react';
import cn from 'classnames';
import { Box } from '../box';
import styles from './styles.module.css';
export const Skeleton = (props) => {
    const { className, size, shape = 'squircle', ...rest } = props;
    return React.createElement(Box, { className: cn(className, styles.skeleton, size && styles[size], styles[shape]), inline: true, ...rest });
};
